import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import mainLogo from './images/graphwarII_logo.png';
import play from './images/play_badge.png';
import apple from './images/app_store_badge.svg';
import steam from './images/steambadge.webp';
import itch from './images/itch_badge.svg';
import discord from './images/discord_mark_white.svg';

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    margin: 0;
    padding: 0;
    width: 100%;
    box-sizing: border-box;
  }


  @media (min-width: 769px) {
    html, body, #root {
      height: 100%;
      overflow: hidden; 
    }
  }


  @media (max-width: 768px) {
    html, body, #root {
      height: auto;
      min-height: 100vh;
    }
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }
`;

function App() {
  return (
    <>
      <GlobalStyle />
      <MainPage>
        <Content>
          <Header>                
            <Graphwar src={mainLogo} alt="Graphwar logo" />      
          </Header>       
      
          <Introdution>   
            <HighlightText>
              <strong>Graphwar II</strong> is an artillery game played on a <span>Cartesian Plane</span> where your weapons are mathematical functions!
            </HighlightText>
            
            <FeatureGrid>
              <FeatureColumn>
                <ColumnTitle>🎯 The Challenge</ColumnTitle>
                <FeatureList>
                  <FeatureItem>
                    <IconSpan>🌀</IconSpan>
                    <span><strong>Write</strong> complex functions</span>
                  </FeatureItem>
                  <FeatureItem>
                    <IconSpan>🛡️</IconSpan>
                    <span><strong>Avoid</strong> obstacles and friendly fire</span>
                  </FeatureItem>
                  <FeatureItem>
                    <IconSpan>💥</IconSpan>
                    <span><strong>Annihilate</strong> targets with math precision</span>
                  </FeatureItem>
                </FeatureList>
              </FeatureColumn>

              <FeatureColumn>
                <ColumnTitle>✨ What's New</ColumnTitle>
                <FeatureList>
                  <FeatureItem>
                    <IconSpan>🖥️</IconSpan>
                    <span>Modern UI & Replays</span>
                  </FeatureItem>
                  <FeatureItem>
                    <IconSpan>🕹️</IconSpan>
                    <span>Single-player campaign & modes</span>
                  </FeatureItem>
                  <FeatureItem>
                    <IconSpan>🎨</IconSpan>
                    <span>Character customization</span>
                  </FeatureItem>
                </FeatureList>
              </FeatureColumn>
            </FeatureGrid>
          </Introdution>
        
          <Video>
            <Iframe 
              src="https://www.youtube.com/embed/We4mI_a1WhI" 
              title="YouTube video player" 
              frameborder="0" 
              allow="accelerometer; 
              autoplay; 
              clipboard-write; 
              encrypted-media; 
              gyroscope; 
              picture-in-picture; 
              web-share" allowfullscreen>
            </Iframe>
          </Video>

          <StoresContainer>
            <Link href="https://play.google.com/store/apps/details?id=com.graphwar.graphwar_ii">
              <BadgeImage src={play} alt="Google Play" />
            </Link>
    
            <Link href="https://apps.apple.com/app/graphwar-ii/id6517357575">
              <BadgeImage src={apple} alt="App Store" />
            </Link>

            <Link href="https://store.steampowered.com/app/3066840/Graphwar_II/">
              <BadgeImage src={steam} alt="Steam" />
            </Link>

            <Link href="https://graphwar.itch.io/graphwar-ii">
              <BadgeImage src={itch} alt="Itch.io" />
            </Link>
          </StoresContainer>

          <SupportContainer>
            <Link href="https://discord.gg/Fmwq7XmCH2">
              <DiscordButton>
                <img src={discord} alt="Discord" />
                <span>Discord</span>
              </DiscordButton>
            </Link>

            <Link href="https://www.buymeacoffee.com/Graphwar" target="_blank" rel="noopener noreferrer">
              <BmcButton>
                <img src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee logo" />
                <span>Buy my wife a coffee</span>
              </BmcButton>
            </Link>
          </SupportContainer>
                        
          <Contact>
            If you have questions or suggestions about Graphwar or Catacorp contact the following email:{' '}
            <MailLink href="mailto:contact@graphwar.com">contact@graphwar.com</MailLink>
          </Contact>
            
          <Legacy>
            Graphwar 1 page is still available&nbsp;<MailLink href="graphwar_1/index.html">here</MailLink>.
          </Legacy>
    
        </Content>
      </MainPage>
    </>
  );
}

// --- ESTILOS ---

const MainPage = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    background-color: #0f281d;
    font-family: Arial, Helvetica, sans-serif;
    color: white;
    font-size: 20px;
    justify-content: center;
    align-items: center;

    @media (min-width: 769px) {
        overflow: hidden;
    }
    
    @media (max-width: 768px) {
        height: auto;
        min-height: 100vh;
        align-items: flex-start;
        overflow-y: auto;
    }
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 70%;
    height: 100%;
    justify-content: space-between;
    background-color: #1a3b2d;
    overflow: hidden;
    
	@media (min-width: 769px) {
        overflow: hidden;
    }
    
    @media (max-width: 768px) {
        width: 100%;
        height: auto;
        min-height: 100vh;
        justify-content: flex-start;
        gap: 24px;
        padding: 24px 16px;
    }
`;

const Header = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 5px;
`;

const Graphwar = styled.img`
    max-width: 100%;
    max-height: 85px; 
    object-fit: contain;
    display: block;
    margin: 0 auto;

    @media (max-width: 768px) {
        max-height: 50px;
    }
`;

const Introdution = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

const HighlightText = styled.p`
    font-size: 18px;
    margin: 0 0 15px 0;
    line-height: 1.4;
    max-width: 800px;
    
    span {
        color: #FFDD00;
        font-weight: bold;
    }

    @media (max-width: 768px) {
        font-size: 14px;
        margin-bottom: 8px;
    }
`;

const FeatureGrid = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 30px;
    width: 100%;
    max-width: 900px;

    @media (max-width: 600px) {
        gap: 10px;
    }
`;

const FeatureColumn = styled.div`
    flex: 1;
    text-align: left;
    background: rgba(0, 0, 0, 0.25); 
    padding: 16px 22px; 
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.05);

    @media (max-width: 768px) {
        padding: 8px 12px;
    }
`;

const ColumnTitle = styled.h3`
    margin: 0 0 10px 0;
    font-size: 20px; 
    color: #FFDD00;
    text-transform: uppercase;
    letter-spacing: 0.75px;
    font-weight: bold;

    @media (max-width: 768px) {
        font-size: 14px;
        margin-bottom: 4px;
    }
`;

const FeatureList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    @media (max-width: 768px) {
        gap: 4px;
    }
`;

const FeatureItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 10px;
    font-size: 16px; 
    line-height: 1.5;

    @media (max-width: 768px) {
        font-size: 12px;
        gap: 6px;
    }
`;

const IconSpan = styled.span`
    flex-shrink: 0;
    display: inline-block;
    text-align: center;
    width: 24px;

    @media (max-width: 768px) {
        width: 18px;
    }
`;

const Video = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 10px;
    flex-grow: 1;
    max-height: 36%; 

    @media (max-width: 768px) {
        max-height: 22%;
    }
`;

const Iframe = styled.iframe`
    width: 100%;
    max-width: 800px; 
    height: 100%;
    border: none;
`;

const StoresContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-top: 10px;

    @media (max-width: 990px) {
        flex-direction: row;
        gap: 10px;
    }
`;

const SupportContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-top: 10px;

    @media (max-width: 990px) {
        flex-direction: row;
        gap: 10px;
    }
`;

const Link = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    height: 52px; 
    
    @media (max-width: 990px) {
        height: 38px;
        width: auto;
    }
`;

const BadgeImage = styled.img`
    height: 100%;
    width: auto;
    object-fit: contain;
`;

const DiscordButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #5865F2;
    color: #ffffff;
    height: 100%;
    width: 185px; 
    border-radius: 6px;
    font-size: 16px; 
    font-weight: bold;
    gap: 10px;

    img {
        height: 26px; 
    }

    @media (max-width: 990px) {
        width: 140px;
        font-size: 13px;
        img { height: 18px; }
    }
`;

const BmcButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFDD00;
  color: #000000;
  font-family: 'Cookie', cursive, Arial, sans-serif;
  font-size: 22px; 
  height: 100%;
  padding: 0 20px;
  border-radius: 6px;
  border: 1px solid #000000;
  gap: 10px;
  white-space: nowrap;

  img {
    height: 26px; 
  }

  @media (max-width: 990px) {
      padding: 0 12px;
      font-size: 16px;
      img { height: 18px; }
  }
`;

const Contact = styled.div`
    margin-top: 8px;
    font-size: 13px;
    text-align: center;
    opacity: 0.8;

    @media (max-width: 768px) {
        font-size: 11px;
        margin-top: 4px;
    }
`;

const MailLink = styled.a`
    color: #FFDD00;
    text-decoration: none;
    font-weight: bold;

    &:hover {
        text-decoration: underline;
    }
`;

const Legacy = styled.div`
    margin-top: 5px;
    width: 100%;
    text-align: center;
    display: flex; 
    flex-direction: row;
    justify-content: center;
    font-size: 13px;
    opacity: 0.8;
    @media (max-width: 460px) {
        font-size: 10px;
        margin-top: 2px;
    }
`;

export default App;
